import { FC, useEffect, useRef, useState } from 'react';
import { Transition } from '@headlessui/react';
import Caret from 'components/Icons/Caret';
import FullscreenOverlay from 'components/Others/FullscreenOverlay';
import useOnClickOutside from 'hooks/useOnClickOutside';
import useWindowSize from 'hooks/useWindowSize';
import { PD_RANGE_BY_FRAME_SIZE, PD_RANGE_BY_FRAME_SIZE_MONO } from 'constants/pdRange';
import React, { ReactElement } from 'react';

interface OverlappingDropdownProps {
    value?: any;
    placeholder: string;
    active: boolean;
    // eslint-disable-next-line no-unused-vars
    updateActiveState: (value: boolean) => void;
    customHeight?: any;
    customWidth?: any;
    onChangePd: any
    pdValue: any;
    type?: string
}

const PdInputOverlappingDropdown: FC<OverlappingDropdownProps> = ({
    value,
    placeholder,
    children,
    active,
    updateActiveState,
    customHeight,
    customWidth,
    onChangePd,
    pdValue,
    type,
}) => {
    const [selectedValue, setSelectedValue] = useState(value);
    const [isActive, setIsActive] = useState(false);
    const [suggestionList, setSuggestionList] = useState<any>(null);

    useEffect(() => {
        if (value != false) {
            setSelectedValue(value);
        }
    }, [value]);

    const [filteredChildren, setFilteredChildren] = useState(children);

    const filterChildren = (insertedPdValue: number) => {
        let newPdChildrens: any = [];
        const suggestions: number[] = [];

        insertedPdValue = Number(insertedPdValue);

        if (placeholder === 'monoR' || placeholder === 'monoL' || placeholder === 'Right' || placeholder === 'Left') {
            if (insertedPdValue == 1) {
                for (let i = 16.5; i < 20; i += 0.5) {
                    suggestions.push(i);
                }
            }
            if (insertedPdValue == 2) {
                for (let i = 20; i < 30; i += 0.5) {
                    suggestions.push(i);
                }
            }
            if (insertedPdValue == 3) {
                for (let i = 30; i < 40; i += 0.5) {
                    suggestions.push(i);
                }
            }
        }

        if (insertedPdValue == 3) {
            for (let i = 33; i < 40; i += 0.5) {
                suggestions.push(i);
            }
        }

        if (insertedPdValue == 4) {
            for (let i = 40; i < 50; i += 0.5) {
                suggestions.push(i);
            }
        }

        if (insertedPdValue == 5) {
            for (let i = 50; i < 60; i += 0.5) {
                suggestions.push(i);
            }
        }

        if (insertedPdValue == 6) {
            for (let i = 60; i < 70; i += 0.5) {
                suggestions.push(i);
            }
        }

        if (insertedPdValue == 7) {
            for (let i = 70; i < 80; i += 0.5) {
                suggestions.push(i);
            }
        }

        if (insertedPdValue > 10 && Number.isInteger(insertedPdValue)) {
            suggestions.push(insertedPdValue, insertedPdValue + 0.5);
        }

        if (insertedPdValue > 10 && !Number.isInteger(insertedPdValue)) {
            suggestions.push(insertedPdValue);
        }

        setSuggestionList(suggestions);
        if (children && Object(children).length > 0) {
            Object(children).forEach((child: any) => {
                const childKey = Number(child.key.replace('_right', '').replace('_left', ''));
                if (suggestions.includes(childKey)) {
                    newPdChildrens.push(child);
                }
            });
        }

        setFilteredChildren(newPdChildrens);
    }

    const handlePdChange = (pd: any) => {
        const { min, max } = (placeholder === 'monoR' || placeholder === 'monoL' || placeholder === 'Right' || placeholder === 'Left') ? PD_RANGE_BY_FRAME_SIZE_MONO['M'] : PD_RANGE_BY_FRAME_SIZE['M'];
        const parsedValue = parseFloat(pd);
        if (parsedValue >= min && parsedValue <= max) {
            if (placeholder === 'bino' || placeholder === 'Select') {
                if (type == 'prescription') {
                    onChangePd(pd);
                } else {
                    onChangePd({
                        ...pdValue,
                        type: 'bino',
                        pd: pd,
                    });
                }
            }

            if (placeholder === 'monoR' || placeholder === 'Right') {
                if (type == 'prescription') {
                    onChangePd(pd);
                } else {
                    onChangePd({
                        ...pdValue,
                        type: 'mono',
                        right: pd,
                        pd: ''
                    });
                }
            }

            if (placeholder === 'monoL' || placeholder === 'Left') {
                if (type == 'prescription') {
                    onChangePd(pd);
                } else {
                    onChangePd({
                        ...pdValue,
                        type: 'mono',
                        left: pd,
                        pd: ''
                    });
                }
            }
        } else {
            if (placeholder === 'bino' || placeholder === 'Select') {
                if (type == 'prescription') {
                    onChangePd(null);
                } else {
                    onChangePd({
                        ...pdValue,
                        type: 'bino',
                        pd: null,
                    });
                }
            }

            if (placeholder === 'monoR' || placeholder === 'Right') {
                if (type == 'prescription') {
                    onChangePd(null);
                } else {
                    onChangePd({
                        ...pdValue,
                        type: 'mono',
                        right: null
                    });
                }
            }

            if (placeholder === 'monoL' || placeholder === 'Left') {
                if (type == 'prescription') {
                    onChangePd(null);
                } else {
                    onChangePd({
                        ...pdValue,
                        type: 'mono',
                        left: null
                    });
                }
            }
        }
    }

    return (
        <div className="relative">
            {/* <label className='text-[#959595] text-[14px] mb-[8px]'>Enter PD value</label> */}
            <input
                data-testid="pd-input"
                placeholder={placeholder == 'monoL' && 'Your Left PD' || placeholder == 'monoR' && 'Your Right PD' || placeholder == 'Right' && 'Your Right PD' || placeholder == 'Left' && 'Your Left PD' || placeholder == 'bino' && 'Your PD' || placeholder == 'Select' && 'Your PD' as any}
                className='custom-number-input bg-brand-white rounded-md h-[38px] px-3 text-sm font-medium text-brand-grey300 border-brand-grey400 ounded-[10px] w-full bg-white border border-brand-grey40'
                type="number"
                value={selectedValue as any}
                onChange={(e: any) => {
                    setSelectedValue(e.target.value);
                    handlePdChange(e.target.value);

                    if (e.target.value == '') {
                        setIsActive(false);
                    } else {
                        filterChildren(Number(e.target.value));
                        setIsActive(true);
                    }
                }}
            />
            <OverlappingDropdownOverlay
                visible={isActive}
                toggleVisibility={() => {
                    setIsActive(false);
                }}
                onSelect={(value: any) => {
                    setIsActive(false);
                    handlePdChange(value.replace('_left', '').replace('_right', ''))
                }}
                customWidth={customWidth}
                placeholder={placeholder}>
                {filteredChildren}
            </OverlappingDropdownOverlay>
        </div>
    );
};

interface OverlappingDropdownOverlayProps {
    visible: boolean;
    toggleVisibility: () => void;
    placeholder: string;
    customWidth?: any;
    onSelect: (value: any) => void;
}

const OverlappingDropdownOverlay: FC<OverlappingDropdownOverlayProps> = ({
    children,
    ...overlayProps
}) => {
    return (
        <OverlappingDropdownDeskopOverlay {...overlayProps}>
            {children}
        </OverlappingDropdownDeskopOverlay>
    );
};

interface ChildProps {
    onClick?: () => void;
    [key: string]: any;
}

const OverlappingDropdownDeskopOverlay: FC<OverlappingDropdownOverlayProps> = ({
    visible,
    toggleVisibility,
    placeholder,
    children,
    customWidth,
    onSelect
}) => {
    const perfectScrollbarInstance = useRef<any>(null);
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!perfectScrollbarInstance?.current) return;
        setTimeout(() => {
            perfectScrollbarInstance.current?.updateScroll?.();
        }, 500);
    }, [perfectScrollbarInstance]);

    useOnClickOutside(wrapperRef, toggleVisibility);

    const handleChildClick = (child: React.ReactElement) => {
        onSelect(child.props.value || child.key);
    };

    const wrappedChildren = React.Children.map(children, (child) => {
        if (React.isValidElement<ChildProps>(child)) {
            return React.cloneElement(child, {
                onClick: () => handleChildClick(child as ReactElement),
                'data-testid': child.props['data-testid']
            });
        }
        return child;
    });

    return (
        <Transition
            show={visible}
            ref={wrapperRef}
            enter="transition ease-in-out duration-[450ms]"
            enterFrom="opacity-0 translate-y-[-25px]"
            enterTo="translate-y-0 opacity-1"
            leave="transition ease-in-out duration-[200ms] transform"
            leaveFrom="translate-y-0 opacity-1"
            leaveTo="translate-y-[-25px] opacity-0"
            className="absolute top-0 left-0 z-[2] min-h-full w-full rounded-[6px] border border-brand-grey350 bg-white py-[16px] mt-[65px]" style={{ width: customWidth }}>
            {children && Object(children).length === 0 &&
                (<div className="px-[16px]">
                    <span
                        className="flex cursor-pointer items-center justify-between text-[14px]"
                        onClick={toggleVisibility}>
                        <span className=" overflow-hidden overflow-ellipsis leading-[18px]">
                            Please enter a valid PD
                        </span>
                    </span>
                </div>)
            }
            <div className="mr-[6px] mt-[12px] max-h-[180px] overflow-auto">
                <div className="pl-[16px] pr-[10px]" data-testid="pd-dropdown-list">{wrappedChildren}</div>
            </div>
        </Transition>
    );
};

export default PdInputOverlappingDropdown;